module.exports = __webpack_public_path__ + "img/xu5-2.662c781f.png";